"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectDiff = exports.objectKeysDeep = void 0;
const deep_object_diff_1 = require("deep-object-diff");
const lodash_1 = __importDefault(require("lodash"));
function objectKeysDeep(object, prefix = '') {
    if (!object) {
        return [];
    }
    if (prefix.length) {
        prefix += '.';
    }
    return Object.keys(object).flatMap((k) => {
        if (object[k] && typeof object[k] == 'object') {
            return objectKeysDeep(object[k], `${prefix}${k}`);
        }
        return `${prefix}${k}`;
    });
}
exports.objectKeysDeep = objectKeysDeep;
function objectDiff(oldValue, newValue) {
    const updated = (0, deep_object_diff_1.diff)(oldValue, newValue);
    const old = {};
    const hasDiff = Object.keys(updated).length != 0;
    if (hasDiff) {
        for (const key of objectKeysDeep(updated)) {
            lodash_1.default.setWith(old, key, lodash_1.default.get(oldValue, key), Object);
        }
    }
    return {
        hasDiff,
        old,
        new: updated,
    };
}
exports.objectDiff = objectDiff;
//# sourceMappingURL=object-diff.js.map